export function initDoc(doc, authId = '') {
    const init = {
        id: '',
        collection: '',
        parent: null,
        createdAt: new Date(),
        createdBy: authId,
        updatedAt: new Date(),
        updatedBy: authId
    };
    return Object.assign(Object.assign({}, init), doc);
}
export function initSearchableDoc(doc, authId = '') {
    const init = Object.assign(Object.assign({}, initDoc(doc, authId)), { searchTerms: [] });
    return Object.assign(Object.assign({}, init), doc);
}
export function generateDocSearchTerms(input, extraTerms = []) {
    const introPhraseCount = 3;
    const cleaned = input.trim().toLowerCase();
    let keys = cleaned.split(' ');
    if (keys.length > 7) {
        // grab first 4 last 4 keys
        keys = [...keys.slice(0, 4), ...keys.slice(keys.length - 4, keys.length)];
    }
    const terms = new Set();
    getAllWordPermutations(keys).forEach((perm) => {
        const words = perm.split(' ');
        let permIntro = '';
        words.forEach((word, index) => {
            if (index < introPhraseCount) {
                permIntro += word + ' ';
            }
        });
        permIntro = permIntro.trim();
        let seq = '';
        for (let i = 0; i < permIntro.length; i++) {
            seq += permIntro[i];
            terms.add(seq);
        }
        terms.add(permIntro);
    });
    // full input
    let fullInput = '';
    for (let i = 0; i < cleaned.length; i++) {
        fullInput += cleaned[i];
        terms.add(fullInput);
    }
    return [...Array.from(terms), ...extraTerms];
}
function getAllWordPermutations(words) {
    const results = [];
    if (words.length === 1 || words.length > 8) {
        // > 9 will run out of mem
        results.push(words[0]);
        return results;
    }
    for (let i = 0; i < words.length; i++) {
        const firstWord = words[i];
        const wordsLeft = words.slice(0, i).concat(words.slice(i + 1, words.length));
        const innerPermutations = getAllWordPermutations(wordsLeft);
        for (let j = 0; j < innerPermutations.length; j++) {
            results.push(`${firstWord} ${innerPermutations[j]}`);
        }
    }
    return results;
}
